import { ORGANIZATIONAL_CHART_LABEL } from "../../constants/Dictionary";
import { PageNames } from "../../types/AppTypes";
import { useBreadCrumb } from "../../hooks/useBreadCrumbs.hooks";

export const Org = () => {
  useBreadCrumb([
    {
      name: ORGANIZATIONAL_CHART_LABEL,
      pathName: PageNames.ORG,
    },
  ]);

  return <></>;
};
